const allGradientIcons = document.querySelectorAll('.gradient-icon')

if (allGradientIcons) {
  allGradientIcons.forEach((icon, index) => {
    const gradient = icon.getElementsByTagName('linearGradient')[0]
    const paths = icon.getElementsByTagName('path')
    const circles = icon.getElementsByTagName('circle')
    if (gradient) {
      gradient.id = "linearGradient" + index
      if (paths) {
        for (let path of paths) {
          path.setAttribute("fill", "url(#linearGradient" + index + ")")
        }
      }
      if (circles) {
        for (let circle of circles) {
          circle.setAttribute("fill", "url(#linearGradient" + index + ")")
        }
      }
    }
  }
  )
}